import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/draft-experiments")({
  component: () => (
    <Breadcrumb label="Draft Experiments" to="/draft-experiments">
      <Outlet />
    </Breadcrumb>
  ),
});
